module.exports = __webpack_public_path__ + "static/media/group-16.ffec5276.svg";